// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7471cbc","692":"04a298fb","867":"8485d311"}[chunkId] + ".chunk.js";
};